<template>
	<span class="error"><SvgIcon icon-name="error" class="flex-icon mr-1" /><slot /></span>
</template>

<script>
import SvgIcon from "@SharedVueComponents/SvgIcon/SvgIcon";

export default {
	components: { SvgIcon },
};
</script>

<style lang="scss" scoped>
.error {
	font-size: 11px;
	line-height: 1.4545454;
	display: flex;
	align-items: flex-start;
	color: $color-error;

	.svg-icon {
		font-size: $fontsize-s;
	}
}
</style>
